import * as apiClient from "./axiosApiClient";
import { joinUrlWithRoute } from "../utils/urlUtils";

const baseUrl = apiClient.REACT_APP_USER_API_BASE_URL;
const authBaseUrl = apiClient.REACT_APP_AUTH_API_BASE_URL;

export function login(credentials) {
  const url = joinUrlWithRoute(baseUrl, "/authenticate");
  return apiClient.post(url, credentials, { credentials: "include" });
}

export function verifyEmailLoginCode(payload) {
  const url = joinUrlWithRoute(baseUrl, "/authenticate/verify-email-code");
  return apiClient.post(url, payload, { credentials: "include" });
}

export function resendEmailLoginCode(payload) {
  const url = joinUrlWithRoute(baseUrl, "/authenticate/resend-email-code");
  return apiClient.post(url, payload);
}

export function forgetTrustedBrowsers() {
  return apiClient.post(joinUrlWithRoute(baseUrl, "/security/forget-browsers"), {}, { credentials: "include" });
}

/** URL of the API endpoint that starts the Google sign-in redirect. */
export function buildGoogleLoginStartUrl(params = {}) {
  const url = new URL(joinUrlWithRoute(authBaseUrl, "/google/login/start"), window.location.origin);
  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === "") return;
    url.searchParams.set(key, String(value));
  });
  return url.toString();
}

export function exchangeGoogleLoginCode(payload) {
  const url = joinUrlWithRoute(authBaseUrl, "/google/login/exchange");
  return apiClient.post(url, payload);
}

// export function logout() {
//   const url = joinUrlWithRoute(baseUrl, "logout");
//   return apiClient.httpDelete(url);
// }

export function getCurrentUser() {
  return apiClient.get(baseUrl);
}
